import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreatorLayoutComponent } from './creator-layout.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { FeatureGuard } from 'src/app/core/guards/feature.guard';
import { CustomIdLoginGuard } from 'src/app/core/guards/custom-id-login/custom-id-login.guard';

const routes: Routes = [
  {
    path: 'creator',
    redirectTo: '/creator/my-omniverse/content-packs',
    pathMatch: 'full',
  },
  {
    path: 'creator',
    component: CreatorLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        canActivate: [FeatureGuard],
        data: { featureFlag: 'creatorHome' },
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'my-omniverse',
        canActivate: [FeatureGuard, CustomIdLoginGuard],
        data: { featureFlag: 'myOmniverse' },
        loadChildren: () =>
          import('./my-omniverse/my-omniverse.module').then(
            (m) => m.MyOmniverseModule,
          ),
      },
      {
        path: 'store',
        canActivate: [FeatureGuard, CustomIdLoginGuard],
        data: { featureFlag: 'creatorStore' },
        loadChildren: () =>
          import('./store/creator-store.module').then(
            (m) => m.CreatorStoreModule,
          ),
      },
      {
        path: 'crm',
        canActivate: [FeatureGuard],
        data: { featureFlag: 'crm' },
        loadChildren: () => import('./crm/crm.module').then((m) => m.CrmModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreatorRoutingModule {}
